<template lang="pug">
	div

		b-alert.g-h-center(variant="info" :show="sessions.isFetching")
			b-spinner.mr-2(small label="Small Spinner")

		sessionsComponent(:sess="_paginatedSessions" :eventID="event.data.id" :_participantID="event.data.is_participant" :_datesRange="eventDatesRange")

		b-pagination.mt-4(v-model="sessionsPaginate.currentPage" :total-rows="sessionsFilteredCommon.length" :per-page="sessionsPaginate.perPage" align="center"  v-if="sessionsFilteredCommon.length>sessionsPaginate.perPage")

		NothingFound(v-if="!sessions.isFetching && !sessionsFilteredCommon.length")

</template>

<script>
	import { mapActions, mapState } from 'vuex'

	// Vue components
	import sessionsComponent from '../components/sessionsList'
	import smoothScrollToEl from "../../../MIXINS/smoothScrollToEl";


	export default {
		name: 'Sessions-Block',
		components: {
			sessionsComponent,
		},
		mixins: [
			smoothScrollToEl,
		],
		data: () => ({
			sessionsPaginate: {
				perPage: 4,
				currentPage: 1,
			},
		}),
		computed: {
			...mapState(['event','page']),
			...mapState({
				sessions: state => state.event.sessions,
				dates: state => state.event.dates,
			}),

			eventDatesRange(){ return (this.dates.data || []) },

			_paginatedSessions(){ return this.paginate(this.sessionsFilteredCommon,this.sessionsPaginate) },

			cbs:() => ({
				cats: (item, filterItem) => item.category.some( num => filterItem.includes(num.id) ),
				days: (item, filterItem) => filterItem.includes( (new Date(item.start_timestamp)).toLocaleDateString() ),
			}),
			sessionsFilteredCommon(){ return this.__filteredArr__(this.sessions.data) },

			__filter__(){
				return this.page.event.filter;
			},
		},
		methods: {
			...mapActions('event/nested/sessions', ['getEventSessions']),

			__filterFn__(item, filter){
				return Object.keys(filter).reduce( (acc,key) =>
					( acc && ( this.cbs[key] ? this.__cbWrp__(item, filter[key], this.cbs[key]) : true) ) ,true)
			},
			__filteredArr__(arr){
				return arr.filter( item => this.__filterFn__(item, this.__filter__) )
			},
			__cbWrp__(item, filterItem, cb){
				return filterItem.length
					? cb(item, filterItem)
					: true
			},
			paginate(arr,{perPage,currentPage}){ return arr.slice(perPage*(currentPage-1), perPage*(currentPage-1)+perPage) },
			checkHash(){
				if ( window.location.hash === '#lectures' ){
					this.smoothScrollToEl('#lectures', 65);
				}
			},
			async mountQueue(){
				await this.$store.dispatch('getEventDates', { id:this.event.data.id });
				await this.$store.dispatch('getEventSessions', { id:this.event.data.id, params: {approved:true} });
				this.checkHash();
			},
		},
		beforeMount(){
			this.mountQueue();
		},
	}
</script>
